export function getChatbotUrl(token) {
    if (!token) throw new Error('No hay token de chatbot disponible.');

    const baseUrl = window.micuentaenv?.CHATBOT_FRONTEND_URL;
    if (!baseUrl) throw new Error('El chatbot no está configurado.');

    return `${baseUrl.replace(/\/$/, '')}/chat/?style=micuenta#token=${encodeURIComponent(token)}`;
}
